<template>
  <div>
    <div v-if="online_fitting">
      <img
              class="shape_img"
              :src="shape_img"
              style="max-width: 100px; max-height: 100px;"
      >

      <p>
        <span class="band_size">Band: <b>{{ $root.underbust_size }}"</b></span>
        <span class="cup_size">Cup: <b>{{ $root.cup_size }}"</b></span>
        <span class="shape">Shape: <b>{{ $root.shapeToDisplayName($root.shape) }}</b></span>
        <span class="shape">Waist:
          <b>
            <template v-if="!$root.skipped_bottoms">
              {{ $root.waist_size }}"
            </template>
            <template v-else>
              Skipped
            </template>
          </b>
        </span>
        <span class="shape">Hip:
          <b>
            <template v-if="!$root.skipped_bottoms">
              {{ $root.hip_size }}"
            </template>
            <template v-else>
              Skipped
            </template>
          </b>
        </span>
      </p>

      <h2>
        Bra size: <b>(US) {{ $root.us_from_uk(online_fitting.fitted_size) }} /
                  (UK) {{ online_fitting.fitted_size }}</b>
        <div style="display: inline-block; width: 10px;" />
        Bottom Size: <b>{{ online_fitting.generic_bottom_simple_size }}</b>
      </h2>

      <h3>What are you looking for?</h3>
      <div class="container">
        <button
          v-for="(value, key) in $root.types"
          :key=key
          class="btn"
          :class="{selected: $root.type === value}"
          @click.prevent="$root.type = value;"
        >
          {{key}}
        </button>
      </div>

      <!-- FIT COMPONENT SLIDER -->
      <h3>What {{ $root.isBottomType ? 'fit' : 'band fit'}} do you prefer?</h3>
      <div
        v-if="online_fitting"
        class="fit"
      >
        <!-- RANGE VALUE SLIDER -->
        <div class="range-value">
          <!-- LOOSE -->
          <div class="flex">
            <button
              class="btn btn-wide btn-slide"
              :class="{selected: $root.fit === 'loose'}"
              @click.prevent="$root.fit = 'loose';"
            >
              <template v-if="$root.isBottomType">
                {{ $root.get_alternate_size(online_fitting.generic_bottom_simple_size, 1) }}
              </template>
              <template v-else>
                {{ $root.us_from_uk(online_fitting.loose_fit) }} US / {{ online_fitting.loose_fit }} UK
              </template>
            </button>
            <span>LOOSE</span>
          </div>

          <!-- NORMAL -->
          <div class="flex">
            <button
              class="btn btn-wide btn-slide"
              :class="{selected: $root.fit === 'normal'}"
              @click.prevent="$root.fit = 'normal';"
            >
              <template v-if="$root.isBottomType">
                {{ online_fitting.generic_bottom_simple_size }}
              </template>
              <template v-else>
                {{ $root.us_from_uk(online_fitting.fitted_size) }} US / {{ online_fitting.fitted_size }} UK
              </template>
            </button>
            <span>SNUG</span>
          </div>

          <!-- SNUG -->
          <div class="flex">
            <button
              class="btn btn-wide btn-slide"
              :class="{selected: $root.fit === 'tight'}"
              @click.prevent="$root.fit = 'tight';"
            >
              <template v-if="$root.isBottomType">
                {{ $root.get_alternate_size(online_fitting.generic_bottom_simple_size, -1) }}
              </template>
              <template v-else>
                {{ $root.us_from_uk(online_fitting.snug_fit) }} US / {{ online_fitting.snug_fit }} UK
              </template>
            </button>
            <span>TIGHT</span>
          </div>

          <!-- INDICATOR -->
          <template>
            <div class="left-indicator" :style="leftComputedStyle"></div>

            <div v-if="$root.isBottomType && online_fitting.bottoms_percentage" class="indicator" :style="computedStyle"></div>
            <div v-else-if="!$root.isBottomType && online_fitting.bra_percentage" class="indicator" :style="computedStyle"></div>

            <div class="right-indicator" :style="rightComputedStyle"></div>
          </template>
        </div>
      </div>
    </div>
    <div v-else>
      Loading...
    </div>
  </div>
</template>

<script>
  import shapes from '../data/shapes';

  export default {
    props: {
      online_fitting: {
        type: Object,
        default: null,
      }
    },
    computed: {
      shape_img(){
        let shape = shapes.find(
          shape => shape.value === this.$root.shape
        );
        if(shape){
          return shape.img;
        }
      },
      computedStyle() {
        if (this.$root.isBottomType) {
          const range = 66.5 - 33.5;
          let val = 33.5 + (range - (range * this.online_fitting.bottoms_percentage))
  
          return { left: val + '%' };
        } else {
          const range = 66.5 - 33.5;
          let val = 33.5 + (range - (range * this.online_fitting.bra_percentage));

          return { left: val + '%' };
        }
      },
      leftComputedStyle() {
        if (this.$root.isBottomType) {
          const range = 66.5 - 33.5;
          let val = 33.5 + (range - (range * this.online_fitting.bottoms_percentage))
          val -= 16.5;

          return { left: val + '%' };
        } else {
          const range = 66.5 - 33.5;
          let val = 33.5 + (range - (range * this.online_fitting.band_percentage));

          return { left: val + '%' };
        }
      },
      rightComputedStyle() {
        if (this.$root.isBottomType) {
          const range = 66.5 - 33.5;
          let val = 33.5 + (range - (range * this.online_fitting.bottoms_percentage))
          val += 16.5;

          return { left: val + '%' };
        } else {
          const range = 66.5 - 33.5;
          let val = 33.5 + (range - (range * this.online_fitting.cup_percentage));

          return { left: val + '%' };
        }
      },
      secondRangeValue() {
        if (!this.online_fitting.bottoms_percentage) {
          return { left: 50 + '%' };
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  button {
    display: inline-block;
    padding: 10px;
    width: 150px;
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 15px;

    &.btn-wide {
      width: 200px;
    }
  }

  .shape_img {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .band_size, .cup_size, .shape {
    margin-left: 15px;
    margin-right: 15px;
  }

  @yellow: #FFF726;
  @pink: rgb(250, 31, 151);
  @blue: #0187cf;
  @red: #FF0000;

  .container {
    max-width: 800px;
    margin: 0 auto;

  }

  .fit .range-value .btn {
    margin: 0px;
    outline: 0;
  }
  .fit .range-value .btn-slide {
      background-color: transparent;
      border: 0px;
      color: rgba(96,106,116,.5);
      border-bottom: 9px solid @yellow;
      width: 100% !important;
      margin-bottom: 8px;
      border-radius: 0px;
      position: relative;
      font-size: 16px;
  }
  .fit .range-value {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      max-width: 1024px;
      margin: 0 auto;
      margin-bottom: 40px;
  }
  .fit .range-value .flex {
      flex: 1;
  }
  .fit .fit-label {
      padding: 0px 10px;
  }
  .fit .range-value .flex:nth-child(3n+2) .btn-slide {
      border-color: @blue;
  }
  .fit .range-value .flex:nth-child(3n+1) .btn-slide {
      border-color: @pink;
  }
  .fit .range-value .btn-slide.selected {
      color: #4a5057;
      font-weight: bold;
  }
  .range-value {
    position: relative;
  }
  .fit .range-value .indicator {
    content: '';
    position: absolute;
    top: calc(100% + 3px);
    transform: translateX(-50%);
    width: 0px;
    height: 0px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 15px solid @red;
  }
  .indicator::after {
    content: 'Your Fit Range';
    position: absolute;
    font-size: .7em;
    width: 100px;
    top: 20px;
    left: -50px;
    color: @red;
  }
  .left-indicator {
    content: '';
    position: absolute;
    top: calc(100% - 57px);
    transform: translateX(-50%);
    width: 0px;
    height: 50px;
    border-left: 3px solid @red;
  }
  .right-indicator {
    content: '';
    position: absolute;
    top: calc(100% - 57px);
    transform: translateX(-50%);
    width: 0px;
    height: 50px;
    border-left: 3px solid @red;
  }
</style>
